import { defineMessages } from 'react-intl';

export default defineMessages({
  selectQuantity: {
    id: 'collectionPDP.ProductVariantSelection.selectQuantity',
    defaultMessage: 'Select Quantity:',
  },
  firstProductAttributesUpperTitle: {
    id: 'collectionPDP.ProductVariantSelection.firstProductAttributesUpperTitle',
    description: 'Upper Title for First Product',
    defaultMessage: 'First {productName}',
  },
  secondProductAttributesUpperTitle: {
    id: 'collectionPDP.ProductVariantSelection.secondProductAttributesUpperTitle',
    description: 'Upper Title for Second Product',
    defaultMessage: 'Second {productName}',
  },
});
